
import React from 'react'

interface ImportExportIconProps {
    size?: string
    color?: string
}

export default function ImportExportIcon({ size="20", color="#79808A" }: ImportExportIconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.17127 14.8027L2.16406 14.8066V14.0923H2.35454V15.6436V15.9991C2.35041 15.9957 2.34635 15.9922 2.34234 15.9888C2.21963 15.8824 2.16849 15.7557 2.16882 15.6425L2.17127 14.8027ZM2.85552 16.1693C2.78348 16.169 2.71406 16.1599 2.6489 16.1436H2.85454H17.1403H17.3506C17.2843 16.1602 17.2136 16.1693 17.1403 16.1693H2.85552ZM17.6557 15.9901C17.6506 15.9944 17.6455 15.9987 17.6403 16.0029V15.6436V14.0923H17.8307V15.6436C17.8307 15.7569 17.7791 15.8837 17.6557 15.9901ZM16.9695 9.48978L14.1641 11.9067L11.3587 9.48978L11.426 9.43181L13.2425 10.9968L14.0688 11.7087V10.618V3.83594H14.2593V10.618V11.7087L15.0857 10.9968L16.9022 9.43181L16.9695 9.48978ZM8.63612 6.41286L8.56883 6.47084L6.75232 4.90585L5.92597 4.19392V5.28466V12.0667H5.73549V5.28466V4.19392L4.90914 4.90585L3.09263 6.47084L3.02534 6.41286L5.83073 3.99591L8.63612 6.41286Z" fill={color} stroke={color}/>
        </svg>
    )
}
